import { isNullOrUndefined } from '@bimser/core';
import * as React from 'react';
import { BCNotification, findMessage } from '../../..';
import BCInput from '../../../BCInput';
import { IPropertyComponentProps, IPropertyItem } from '../../entities';

const defaultStyle: React.CSSProperties = { width: '100%' };

export default function InputProperty(props: IPropertyComponentProps) {
	const {
		allowNull,
		triggerChangeOnBlur,
		reservedValues,
		isLiquid,
		maxLength,
		type,
		regExp,
		addonBefore,
		addonAfter
	} = props.item.externalData || {};

	const triggerChange = (value: string) => {
		if (allowNull === false && (value === '' || isNullOrUndefined(value))) {
			value = props.value;
			BCNotification.error({
				message: findMessage.get('100652'),
				description: findMessage.get('100079').replace('$0', props.item.key)
			});
		}
		props.customChangeEvent ? props.customChangeEvent(value) : replaceValue(props.item, value);
	};

	const replaceValue = (item: IPropertyItem, newValue: any) => {
		props.onValueChanged(item, newValue);
	};

	const onChange = (e: any) => {
		const value = e.data;

		const result = checkReservedValues(value);

		if (result) {
			if (!triggerChangeOnBlur) {
				triggerChange(value);
			}
		} else if (reservedValues?.warningMessage) {
			BCNotification.error(reservedValues.warningMessage);
		}
	};

	const checkReservedValues = (value: string) => {
		if (reservedValues?.keys) {
			const keys: string[] = reservedValues.keys;

			return !keys.find(i => i.toLowerCase() === value.toLowerCase());
		}

		return true;
	};

	const onBlur = (ev: React.FocusEvent<HTMLInputElement>) => {
		const val: string = ev.target.value;
		if (isLiquid) {
			const newString = checkLiquidRemake(val);
			if (val != newString) {
				triggerChange(newString);
			}
		}

		if (triggerChangeOnBlur && val != props.value) {
			triggerChange(val);
		}
	};

	const checkLiquidRemake = (str: string) => {
		const dotPlaceholder = '__REPLACE_DOT__';
		str = str.replaceAll('.', dotPlaceholder);
		const allMachted = (str as any).matchAll(/{( |)+\w+( |)+}/gm);
		let current = allMachted.next();
		let newString: string = str;
		while (!current.done) {
			const startIndex: number = current.value.index;
			const matchedText: string = current.value[0];
			const hasOpenScope: boolean = startIndex - 1 >= 0 && str[startIndex - 1] === '{';
			const hasOutScope: boolean =
				str.length > matchedText.length + startIndex &&
				str[matchedText.length + startIndex] === '}';
			if ((hasOpenScope && !hasOutScope) || (!hasOpenScope && hasOutScope)) {
				if (hasOpenScope) {
					//add out
					newString = insertString(newString, '}', matchedText.length + startIndex);
				}
				if (hasOutScope) {
					newString = insertString(newString, '{', startIndex);
				}
			}
			current = allMachted.next();
		}
		const _clone = newString.valueOf();
		const noHaveAnyOutScope = (_clone as any).matchAll(/{{( |)+\w+/gm);
		current = noHaveAnyOutScope.next();
		while (!current.done) {
			const startIndex: number = current.value.index;
			const matchedText: string = current.value[0];
			const remainingText = _clone.slice(startIndex + matchedText.length).trim();
			if (!remainingText.startsWith('}}')) {
				const insterText = matchedText.split(' ')[0] == '{{' ? ' }} ' : '}} ';
				newString = insertString(newString, insterText, startIndex + matchedText.length);
			}
			current = noHaveAnyOutScope.next();
		}
		return newString.replaceAll(dotPlaceholder, '.');
	};

	const insertString = (str: string, insert: string, index: number) =>
		str.slice(0, index) + insert + str.slice(index);

	return (
		<BCInput
			maxLength={maxLength}
			value={props.value || props.item.placeholder}
			type={type}
			disabled={props.item.disabled}
			readOnly={props.item.readOnly || props.readonly}
			onBlur={onBlur}
			style={props.style || defaultStyle}
			regExp={regExp}
			addonBefore={addonBefore}
			addonAfter={addonAfter}
			onChange={onChange}
			size="small"
		/>
	);
}
